




































































































































import { Component, Watch } from 'vue-property-decorator';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { actionsEvent } from '@/setup';

import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Confirmation from '@/components/Confirmation.vue';

import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';

import {
  ParamsApi,
  ClearParam,
  MsgParam,
  IdParams,
  DataApi,
  FiltersApi,
} from './models/ContratosSiga.model';

import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import { fetchContratosSiga } from './fetchContratosSiga';
import PopUpGeneratedReports from './PopUpGeneratedReports.vue';
import Formulario from './Formulario.vue';
@Component({
  components: {
    Confirmation,
    MantenedorGridSinCodigo,
    DatePicker,
    FormFieldsContainer,
    Formulario,
  },
})
export default class ContratosSigaBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.Atenciones;

  verDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };

  anular: PermisoAccion = {
    accionCodigo: 94,
    visible: false,
  };

  readonly accionesTotales: PermisoAccion[] = [this.verDetalle, this.anular];

  columnApi: any = null;
  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  dataList: DataApi[] = [];

  dialogPopUp: boolean = false;
  activateChangeFn: boolean = false;
  showModalViewDetail: boolean = false;
  showPopUpReport: boolean = false;
  filtro: string = '';
  showImportar = false;
  now: string = moment().format('YYYY-MM-DD');
  msgReport: string = '';

  numConfirmations: number = 0;

  confirmationData: Record<string, string> = {
    atenumero: '',
    ateestado: '',
    title: '',
    msgConfirmation: '',
  };

  data: DataApi = {};
  filter: FiltersApi[] = [
    { configlbl: 'Activo', configval: true },
    { configlbl: 'Inactivo', configval: false },
  ];
  objectParam: ParamsApi = {
    start_date: null,
    end_date: null,
    codigo_contrato: '',
    patente: '',
  };
  currentObjectParam: ParamsApi = {};
  timeout: { timeout: number } = { timeout: 3000 };
  accion: string;
  fecha_facturacion: string | moment.Moment = moment();
  mostrarHijo: boolean = false;
  constructor() {
    super();
    this.columnDefs = this.colsGrid();
    this.generaActionsEvent();
    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }
  generaActionsEvent() {}
  colsGrid(): ColDef[] {
    const cols = [
      { field: 'Compañía', id: 'compania' },
      { field: 'Código Contrato', id: 'codigo_contrato' },
      { field: 'Descripción Contrato', id: 'descripcion_contrato' },
      { field: 'RUT Administrador Contrato', id: 'rut_administrador_contrato' },
      {
        field: 'Nombre Administrador Contrato',
        id: 'nombre_administrador_contrato',
      },
      {
        field: 'Correo Administrador Contrato',
        id: 'correo_administrador_contrato',
      },
      {
        field: 'RUT Administrador Suplente Contrato',
        id: 'rut_administrador_suplente_contrato',
      },
      {
        field: 'Nombre Administrador Suplente Contrato',
        id: 'nombre_administrador_suplente_contrato',
      },
      {
        field: 'Correo Administrador Suplente Contrato',
        id: 'correo_administrador_suplente_contrato',
      },
      { field: 'Fecha Inicio', id: 'fecha_inicio' },
      { field: 'Fecha Término', id: 'fecha_termino' },
      { field: 'Dotación Contratada', id: 'dotacion_contratada' },
      { field: 'Dotación Vehículo', id: 'dotacion_vehiculo' },
      { field: 'Fecha Acreditación', id: 'fecha_acreditacion' },
      { field: 'RUT EECC', id: 'rut_eecc' },
      { field: 'Razón Social EECC', id: 'razon_social_eecc' },
      { field: 'RUT Administrador EECC', id: 'rut_administrador_eecc' },
      { field: 'Nombre Administrador EECC', id: 'nombre_administrador_eecc' },
      { field: 'Correo Administrador EECC', id: 'correo_administrador_eecc' },
      {
        field: 'RUT Administrador Suplente EECC',
        id: 'rut_administrador_suplente_eecc',
      },
      {
        field: 'Nombre Administrador Suplente EECC',
        id: 'nombre_administrador_suplente_eecc',
      },
      {
        field: 'Correo Administrador Suplente EECC',
        id: 'correo_administrador_suplente_eecc',
      },
      { field: 'Controla Dotación', id: 'controla_dotacion' },
      { field: 'Reporte FTE', id: 'reporte_fte' },
      { field: 'Patrón Consumo', id: 'patron_consumo' },
      {
        field: 'RUT Proveedor Subcontratista',
        id: 'rut_proveedor_sub_contratista',
      },
      {
        field: 'Nombre Proveedor Subcontratista',
        id: 'nombre_proveedor_sub_contratista',
      },
      { field: 'Patente', id: 'patente' },
      { field: 'Marca', id: 'marca' },
      { field: 'Modelo', id: 'modelo' },
      { field: 'Año', id: 'ano' },
      { field: 'Pase', id: 'pase' },
      { field: 'Estado Acreditación', id: 'estado_acreditacion' },
      { field: 'Tipo Vehículo', id: 'tipo_vehiculo' },
    ];

    return cols.map(col => {
      return {
        headerName: col.field,
        field: col.id,
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 220,
        minWidth: 100,
      };
    });
  }

  async handleMainGridReady(event: GridReadyEvent): Promise<void> {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.reloadGrid({});
  }

  async reloadGrid({ clear = false }: ClearParam): Promise<void> {
    clear && this.clear();
    this.dataList = await this.getAll();
    this.gridApi.setRowData(this.dataList);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleShowPopUp(confirmation: boolean): void {
    if (!confirmation) {
      this.mostrarHijo = false;
      return this.clearDataPopUp();
    }
    this.numConfirmations++;
    this.validateSatateValue({
      numConfirmations: this.numConfirmations,
      atenumero: this.confirmationData.atenumero,
      ateestado: this.confirmationData.ateestado,
    });
  }
  moduloModalCallback(val: boolean) {
    this.showImportar = val;
    // this.filtrar();
  }
  async archivoImportado(data: any) {
    await this.generarReporte(data);
    this.showImportar = false;
  }

  async generarReporte(data: any) {
    let self = this;
    this.loadingService.showLoading();
    console.log('data', data);
    const filename = data.name;
    // Crea una nueva promesa que se resuelve con el archivo en Base64
    const fileToBase64 = new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
    const base64 = await fileToBase64;
    let body = {
      usuario_id: this.getUserId(),
      clienteDefecto: JSON.parse(localStorage.getItem('user')).clienteDefecto,
      csv: base64,
      filename,
    };
    return fetchContratosSiga({
      endpoint: 'importar_csv',
      body: body,
    })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          // this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          // this.showReporteGenerado = true;
          this.reloadGrid({});
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al importar excel', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  validateSatateValue({
    numConfirmations,
    atenumero,
    ateestado,
    accion,
  }: IdParams): void {
    this.envia_desactivar_certificados({
      numConfirmations,
      atenumero,
      ateestado,
      accion,
    });
  }
  envia_desactivar_certificados(params: any): void {
    if (params.numConfirmations === 1) {
      this.dialogPopUp = false;
      // this.mostrarHijo = true;
      this.confirmationData.title = `Edición de Certificados`;
      this.confirmationData.msgConfirmation = `¿Está seguro que desea desactivar los certificados seleccionados?`;
      setTimeout(() => (this.dialogPopUp = true), 800);
      return;
    }
    if (params.numConfirmations === 2) {
      this.updateEstado();
      this.clearDataPopUp();
      this.mostrarHijo = false;
      return;
    }
    this.mostrarHijo = false;
    this.clearDataPopUp();
  }

  show_modal(): void {
    this.showImportar = true;
  }
  handleFilters(): void {
    if (
      this.objectParam.codigo_contrato &&
      this.objectParam.codigo_contrato !==
        this.currentObjectParam.codigo_contrato
    ) {
      this.activateChangeFn = false;
      return;
    }
    if (
      this.objectParam.codigo_contrato ===
      this.currentObjectParam.codigo_contrato
    ) {
      this.reloadGrid({});
      return;
    }
    if (this.activateChangeFn || this.objectParam.codigo_contrato === null) {
      this.objectParam.codigo_contrato = '';
      this.reloadGrid({});
      return;
    }
  }

  handleSearchFilter(): void {
    if (
      this.objectParam.codigo_contrato &&
      this.objectParam.codigo_contrato !==
        this.currentObjectParam.codigo_contrato
    ) {
      this.activateChangeFn = false;
      this.currentObjectParam = { ...this.objectParam };
      this.reloadGrid({});
      return;
    }
    this.activateChangeFn = true;
    this.currentObjectParam = { ...this.objectParam };
    this.reloadGrid({});
  }

  handleViewDetail(params: any) {
    // console.log('params', params);
    this.data = params.data;
    this.showModalViewDetail = true;
  }

  handleClosedModal() {
    this.showModalViewDetail = false;
    this.data = {};
  }

  handleCloseReport(): void {
    this.showPopUpReport = false;
    this.msgReport = '';
  }

  preventMinusKey(event: KeyboardEvent): void {
    const { key } = event;
    // Permitir tecla de retroceso
    if (['Backspace', 'Shift', 'ArrowLeft', 'ArrowRight'].includes(key)) {
      return;
    }

    // Permitir solo números enteros positivos
    if (key === 'Dead') {
      event.preventDefault();
      return;
    }

    const isValid = /^\d+$/.test(key);

    if (!isValid) {
      event.preventDefault();
    }
  }

  clear(): void {
    Object.keys(this.objectParam).forEach(
      key =>
        ((this.objectParam[key as keyof ParamsApi] as any) =
          key === 'start_date' ? null : key === 'end_date' ? null : '')
    );
    this.activateChangeFn = false;
    this.currentObjectParam = {};
  }

  clearDataPopUp(): void {
    this.dialogPopUp = false;
    this.numConfirmations = 0;
    Object.keys(this.confirmationData).forEach(
      key => (this.confirmationData[key] = '')
    );
  }

  validateError({ msg }: MsgParam): void {
    if (msg === 'Request failed with status code 500') {
      this.$snotify.error(
        'El servicio no se encuentra disponible, por favor intente más tarde',
        { ...this.timeout }
      );
    } else {
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { ...this.timeout }
      );
    }
    throw msg;
  }

  async getAll(): Promise<DataApi[]> {
    this.loadingService.showLoading();
    const self = this;
    return await fetchContratosSiga({ body: { ...this.objectParam } })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;

        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { ...self.timeout });
          return [];
        }
        return LISTA;
      })
      .catch((err: Error) => {
        err instanceof Error && self.validateError({ msg: err.message });
        throw err;
      })
      .finally(() => self.loadingService.hideLoading());
  }

  async updateEstado(): Promise<void> {
    this.loadingService.showLoading();
    const self = this;
    let body: { [key: string]: any } = {
      usuario: this.getUserId(),
      certificados: this.gridApi.getSelectedRows(),
      estado: false,
    };
    return await fetchContratosSiga({
      endpoint: 'update_certificado',
      body: body,
    })
      .then(response => {
        const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA } = response.data;

        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { ...self.timeout });
        } else {
          self.$snotify.success(MENSAJE_RESPUESTA, { ...self.timeout });
        }
        self.reloadGrid({});
      })
      .catch(
        (err: Error) =>
          err instanceof Error && self.validateError({ msg: err.message })
      )
      .finally(() => self.loadingService.hideLoading());
  }
  getUserId(): number {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return parseInt(id);
  }
  @Watch('objectParam.start_date')
  startDateChange() {
    if (this.objectParam.start_date > this.objectParam.end_date) {
      this.objectParam.end_date = this.objectParam.start_date;
    }
    this.handleFilters();
  }

  @Watch('objectParam.end_date')
  endDateChange() {
    if (this.objectParam.end_date < this.objectParam.start_date) {
      this.objectParam.start_date = this.objectParam.end_date;
    }
    this.handleFilters();
  }
}
